<p-toast></p-toast>
<div class="mi-survey-container">
    <p-card styleClass="p-card-shadow">
        <div class="card dashboardTable">
            <p-table #miSurvey [value]="miSurveyData" [(selection)]="filteredDataForExport" dataKey="AppId_ProgID"
                (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
                [paginator]="true" [globalFilterFields]="[
                'Scheme_Specific_Id',
                'Full_Name_In_English',
                'Full_Name_in_Recognized_Official_Language', 
                'GST_NO',
                'Address_Line_1',
                'Address_Line_2',
                'Address_Line_3',
                'District',
                'State', 
                'Country', 
                'Vendor_Bank_Name', 
                'Vendor_IFSC_Code',
                'Vendor_Account_Number', 
                'Vendor_Pan_Card_No', 
                'Pincode', 
                'Farmer_Share_To_Vendor',
                'FinYear',
                'ApplicantType',
                'UserType',
                'MIArea',
                'Caste_Description',
                'Center_Share_Payment_Amount',
                'State_Share_Payment_Amount',
                'TopUp',
                'Village',
                'Block',
                'Total_Area',
                'Crop_Name',
                'FarmerType',
                'Aadhar_Number'
                ]" responsiveLayout="scroll" [rowHover]="true" currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [paginator]="true" [rows]="10" [selectionPageOnly]="true" [rowsPerPageOptions]="[10,25,50,100,500,1000,1500,3000,5000]" [loading]="loading">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'FARMER_APPLICATION_FOR_MI_SUBSIDY_TO_VENDOR'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th pSortableColumn="">{{'VIEW_APPLICATION'| translate}}</th>
                        <th pSortableColumn="Full_Name_In_English">{{'FULL_NAME_IN_ENGLISH'| translate}}
                            <p-columnFilter type="text" field="Full_Name_In_English" display="menu"></p-columnFilter>
                            <p-sortIcon field="Full_Name_In_English"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Full_Name_in_Recognized_Official_Language">{{'FULL_NAME_RECOGNIZED'| translate}}
                            <p-columnFilter type="text" field="Full_Name_in_Recognized_Official_Language"
                                display="menu"></p-columnFilter>
                            <p-sortIcon field="Full_Name_in_Recognized_Official_Language"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Caste_Description">{{'CASTE'| translate}}
                            <p-columnFilter type="text" field="Caste_Description"
                                display="menu"></p-columnFilter>
                            <p-sortIcon field="Caste_Description"></p-sortIcon>
                        </th>
                        <th pSortableColumn="GST_NO">{{'GST_NO'| translate}}
                            <p-columnFilter type="text" field="GST_NO" display="menu"></p-columnFilter>
                            <p-sortIcon field="GST_NO"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Address_Line_1">{{'ADDRESS_LINE_1'| translate}}
                            <p-columnFilter type="text" field="Address_Line_1" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address_Line_1"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Address_Line_2">{{'ADDRESS_LINE_2'| translate}}
                            <p-columnFilter type="text" field="Address_Line_2" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address_Line_2"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Address_Line_3">{{'ADDRESS_LINE_3'| translate}}
                            <p-columnFilter type="text" field="Address_Line_3" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address_Line_3"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Village">{{'Village' | translate}}
                            <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                            <p-sortIcon field="Village"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Block">{{'BLOCK' | translate}}
                            <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                            <p-sortIcon field="Block"></p-sortIcon>
                        </th>
                        <th pSortableColumn="District">{{'DISTRICT'| translate}}
                            <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                            <p-sortIcon field="District"></p-sortIcon>
                        </th>
                        <th pSortableColumn="State">{{'STATE'| translate}}
                            <p-columnFilter type="text" field="State" display="menu"></p-columnFilter>
                            <p-sortIcon field="State"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Country">{{'COUNTRY'| translate}}
                            <p-columnFilter type="text" field="Country" display="menu"></p-columnFilter>
                            <p-sortIcon field="Country"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FarmerType">{{'FARMER_TYPE' | translate}}
                            <p-columnFilter type="text" field="FarmerType" display="menu"></p-columnFilter>
                            <p-sortIcon field="FarmerType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Vendor_Bank_Name">{{'VENDOR_BANK_NAME'| translate}}
                            <p-columnFilter type="text" field="Vendor_Bank_Name" display="menu"></p-columnFilter>
                            <p-sortIcon field="Vendor_Bank_Name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Vendor_IFSC_Code">{{'VENDOR_IFSC_CODE'| translate}}
                            <p-columnFilter type="text" field="Vendor_IFSC_Code" display="menu"></p-columnFilter>
                            <p-sortIcon field="Vendor_IFSC_Code"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Vendor_Account_Number">{{'VENDOR_ACCOUNT_NUMBER'| translate}}
                            <p-columnFilter type="text" field="Vendor_Account_Number" display="menu"></p-columnFilter>
                            <p-sortIcon field="Vendor_Account_Number"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Vendor_Pan_Card_No">{{'VENDOR_PAN_CARD_NO'| translate}}
                            <p-columnFilter type="text" field="Vendor_Pan_Card_No" display="menu"></p-columnFilter>
                            <p-sortIcon field="Vendor_Pan_Card_No"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Aadhar_Number">{{'AADHAR_NUMBER'| translate}}
                            <p-columnFilter type="text" field="Aadhar_Number" display="menu"></p-columnFilter>
                            <p-sortIcon field="Aadhar_Number"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Pincode">{{'PINCODE'| translate}}
                            <p-columnFilter type="text" field="Pincode" display="menu"></p-columnFilter>
                            <p-sortIcon field="Pincode"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Scheme_Specific_Id">{{'SCHEME_SPECIFIC_ID'| translate}}
                            <p-columnFilter type="text" field="Scheme_Specific_Id" display="menu"></p-columnFilter>
                            <p-sortIcon field="Scheme_Specific_Id"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Center_Share_Payment_Amount">{{'CENTER_SHARE_PAYMENT'| translate}}
                            <p-columnFilter type="text" field="Center_Share_Payment_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="Center_Share_Payment_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="State_Share_Payment_Amount">{{'STATE_SHARE_PAYMENT'| translate}}
                            <p-columnFilter type="text" field="State_Share_Payment_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="State_Share_Payment_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TopUp">{{'TOP_UP'| translate}}
                            <p-columnFilter type="text" field="TopUp" display="menu"></p-columnFilter>
                            <p-sortIcon field="TopUp"></p-sortIcon>
                        </th>
                        <!-- <th pSortableColumn="Farmer_Share_To_Vendor">{{'CHALLAN_AMOUNT_DEPOSITED'| translate}}
                            <p-columnFilter type="text" field="Farmer_Share_To_Vendor" display="menu"></p-columnFilter>
                            <p-sortIcon field="Farmer_Share_To_Vendor"></p-sortIcon>
                        </th> -->
                        <th pSortableColumn="ApplicantType">{{'APPLICATION_TYPE'| translate}}
                            <p-columnFilter type="text" field="ApplicantType" display="menu"></p-columnFilter>
                            <p-sortIcon field="ApplicantType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Programme_Name">{{'PROGRAM_NAME'| translate}}
                            <p-columnFilter type="text" field="Programme_Name" display="menu"></p-columnFilter>
                            <p-sortIcon field="Programme_Name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Crop_Name">{{'CROP_NAME' | translate}}
                            <p-columnFilter type="text" field="Crop_Name" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Crop_Name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="UserType">{{'USER_TYPE'| translate}}
                            <p-columnFilter type="text" field="UserType" display="menu"></p-columnFilter>
                            <p-sortIcon field="UserType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="MIArea">{{'MIAREA'| translate}}
                            <p-columnFilter type="text" field="MIArea" display="menu"></p-columnFilter>
                            <p-sortIcon field="MIArea"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Total_Area">{{'TOTAL_LAND_HOLDING' | translate}}
                            <p-columnFilter type="Total_Area" field="Total_Area" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="MIArea"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                            <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                            <p-sortIcon field="FinYear"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="product"></p-tableCheckbox>
                        </td>
                        <td>
                            <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                                class="p-button-rounded p-button-accent mr-1 btnSize"
                                (click)="selectFarmerApplication(product)"></button>
                        </td>
                        <td>{{product?.Full_Name_In_English}}</td>
                        <td>{{product?.Full_Name_in_Recognized_Official_Language}}</td>
                        <td>{{product?.Caste_Description}}</td>
                        <td>{{product?.GST_NO}}</td>
                        <td>{{product?.Address_Line_1}}</td>
                        <td>{{product?.Address_Line_2}}</td>
                        <td>{{product?.Address_Line_3}}</td>
                        <td>{{product?.Village}}</td>
                        <td>{{product?.Block}}</td>
                        <td>{{product?.District}}</td>
                        <td>{{product?.State}}</td>
                        <td>{{product?.Country}}</td>
                        <td>{{product?.FarmerType}}</td>
                        <td>{{product?.Vendor_Bank_Name}}</td>
                        <td>{{product?.Vendor_IFSC_Code}}</td>
                        <td>{{product?.Vendor_Account_Number}}</td>
                        <td>{{product?.Vendor_Pan_Card_No}}</td>
                        <td>{{product?.Aadhar_Number}}</td>
                        <td>{{product?.Pincode}}</td>
                        <td>{{product?.Scheme_Specific_Id}}</td>
                        <td>{{product?.Center_Share_Payment_Amount}}</td>
                        <td>{{product?.State_Share_Payment_Amount}}</td>
                        <td>{{product?.TopUp}}</td>
                        <!-- <td>{{product?.Farmer_Share_To_Vendor}}</td> -->
                        <td>{{product?.ApplicantType}}</td>
                        <td>{{product?.Programme_Name}}</td>
                        <td>{{product?.Crop_Name}}</td>
                        <td>{{product?.UserType}}</td>
                        <td>{{product?.MIArea}}</td>
                        <td>{{product?.Total_Area}}</td>
                        <td>{{product?.FinYear}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}} {{miSurveyData ? miSurveyData.length : 0 }} {{'MI_SUBSIDY_TO_VENDOR_LOT'| translate}}
                    </div>
                </ng-template>
            </p-table>
        </div>
        <div class="card" *ngIf="filteredData.length">
            <h5><b>{{'TOTAL_NO_OF_APPLICATIONS_FILTERED_FOR_MI_SUBSIDY_TO_VENDOR_LOT'| translate}}: {{ totalSelectedApp }}</b></h5>

            <div class="flex justify-content-end">
                <button (click)="menu.toggle($event)" pButton pRipple p-button-info label="Download Filtered Lot Data"
                    icon="pi pi-upload"></button>
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </div>

            <div class="card">
                <p-toolbar *ngIf="filteredData.length">
                    <ng-template pTemplate="left">

                    </ng-template>
                    <ng-template pTemplate="right">
                        <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status" class="mr-3">
                        </p-dropdown>
                        <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea required
                            rows="3" cols="20" class="mr-3"></textarea>
                        <button pButton pRipple label=" {{'SUBMIT'| translate}}" (click)="handleClick()" class="p-button-help"></button>
                    </ng-template>
                </p-toolbar>
            </div>
        </div>
    </p-card>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog><p-toast></p-toast>